import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=d3f61d5e&scoped=true"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"
import style0 from "./WhatsApp.vue?vue&type=style&index=0&id=d3f61d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f61d5e",
  null
  
)

export default component.exports